import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './componenets/HomePage';
import ArtistDashboard from './componenets/ArtistDashboard';
import ArtistLogin from './componenets/ArtistLogin';
import BlogSection from './componenets/BlogSection';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/artist-login" element={<ArtistLogin />} />
          <Route path="/artist-dashboard" element={<ArtistDashboard />} />
          <Route path="/blog" element={<BlogSection />} />
          <Route path="/blog/:slug" element={<BlogSection />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;